import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { userActions } from '../../../../redux/actions/user'
import Box from '../../../Shared/Box'
import { Col, Container, Row } from '../../../Shared/Grid'
import DefaultLayout from '../../DefaultLayout'
import Loader from '../../../Shared/Loader'
import PropTypes from 'prop-types'
import { withRouter } from '../../../Shared/Routing/withRouter'

class OAuthLandingPage extends PureComponent {

  state = {
    initialized: false,
  }

  componentDidMount () {
    this.login()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (
      prevProps.router !== this.props.router
    ) {
      this.login()
    }
  }

  login () {
    if (this.state.initialized) {
      return
    }
    const hash = this.props.router.location.hash.substr(1)
    const urlParams = new URLSearchParams(hash)
    if (urlParams.has('error')) {
      const errorDescription = urlParams.has('error_description') ? urlParams.get('error_description') : ''
      this.setState({ error: errorDescription })
      return
    }
    let idToken = null
    if (!urlParams.has('id_token')) {

      this.setState({ error: 'id_token missing' })
      return
    }
    idToken = urlParams.get('id_token')
    let fromUrl = '/'
    const state = urlParams.get('state')
    let stateDecoded = null
    try {
      stateDecoded = JSON.parse(this.b64DecodeUnicode(state))
    } catch (e) {
      console.log(e)
    }

    if (Object(stateDecoded) === stateDecoded && stateDecoded.hasOwnProperty('from')) {
      fromUrl = stateDecoded.from
    }

    this.props.login(idToken, fromUrl, fromUrl)
    this.setState({ initialized: true })
  }

  // https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
  b64DecodeUnicode (str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
  }

  render () {
    return (
      <DefaultLayout>
        <div className="page page-oauth-landing-page">
          <Box>
            {this.props.loggingIn ? <Loader size={40}/> : null}
            {this.state.error ? <Container fluid gutterWidth={5}>
              {
                this.state.error ? <Row>
                  <Col xs={12}>
                    {this.state.error}
                  </Col>
                </Row> : null
              }
            </Container> : null}
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggedIn: !!state.user.loggedIn,
    loggingIn: !!state.user.loggingIn,
  }
}

const mapDispatchToProps = {
  login: userActions.login
}

OAuthLandingPage.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  loggingIn: PropTypes.bool.isRequired,
  login: PropTypes.func.isRequired,
  router: PropTypes.object
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OAuthLandingPage))
